import { Trans, useTranslation } from "react-i18next";

import { useConfigContext } from "shared/contexts/ConfigContext";

const NotFound = () => {
  const { t } = useTranslation("pages");
  const { general } = useConfigContext();
  const email = general.helpContactEmail;

  return (
    <>
      <div className="text-lg font-semibold">{t("not_found.heading")}</div>
      <div>
        {email ? (
          <Trans
            t={t}
            i18nKey="not_found.error_contact_email"
            values={{ email }}
            components={{
              emailLink: (
                <a
                  href={`mailto:${email}`}
                  className="text-blue-400 hover:text-blue-500"
                />
              ),
            }}
          />
        ) : (
          t("not_found.error_contact_admin")
        )}
      </div>
    </>
  );
};

export default NotFound;
